import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import './RDButton.scss';

const RDButton = ({ btnType, btnStyle, btnIcon, btnClick, btnDisabled, btnText }) => (
  <Button type={btnType} style={btnStyle} icon={btnIcon} onClick={btnClick} disabled={btnDisabled}>
    {btnText}
  </Button>
);

RDButton.defaultProps = {
  btnType: 'primary',
  btnStyle: {},
  btnIcon: undefined,
  btnDisabled: false,
  btnText: '',
  btnClick: () => {},
};

RDButton.propTypes = {
  /** Can be set to- primary | ghost | dashed | link | text | default */
  btnType: PropTypes.string,
  /** Button title */
  btnText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Inline style to apply to the button container */
  btnStyle: PropTypes.shape({}),
  /** Set the handler to handle click event */
  btnClick: PropTypes.func,
  /** Set the icon component of button */
  btnIcon: PropTypes.element,
  /** Disabled state of button */
  btnDisabled: PropTypes.bool,
};

export default RDButton;
